<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Bảng tổng hợp thông tin về các cơ sở giáo dục&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Năm</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}"
              (nzOnOpenChange)="changeYear()" nzPlaceHolder="Nhập năm"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Tỉnh thành</nz-form-label>
          <asc-autocomplete [ascModel]="DisProvincesControl" (ascModelChange)="changeDisProvincesACFn($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Quận huyện</nz-form-label>
          <asc-autocomplete [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Phường xã</nz-form-label>
          <asc-autocomplete [ascModel]="DisWardControl" (ascModelChange)="changeDisWardACFn($event)"
            placeholder="Chọn Phường xã..." [getListAC]="getDisWardACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <ng-container *ngIf="!isCollapse">
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Cấp học</nz-form-label>
            <asc-autocomplete [ascModel]="DisSchoolLevelsControl" (ascModelChange)="changeDisSchoolLevels($event)"
              placeholder="Chọn cấp học, trình độ đào tạo..." [getListAC]="getDisSchoolLevelsACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Loại cơ sở</nz-form-label>
            <asc-autocomplete [ascModel]="TypeofEducationControl" (ascModelChange)="changeEducationACFn($event)"
              placeholder="Chọn loại cơ sở..." [getListAC]="getTypeofEducationACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Loại hình</nz-form-label>
            <asc-autocomplete [ascModel]="disTypeOfSchoolsControl" (ascModelChange)="changeDisTypeOfSchools($event)"
              placeholder="Chọn loại hình..." [getListAC]="getDisTypeOfSchoolsACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="quanHuyen">Điều kiện</nz-form-label>
            <asc-autocomplete [ascModel]="LivingConditionControl" (ascModelChange)="changeLivingCondition($event)"
              placeholder="Chọn điều kiện..." [getListAC]="getLivingConditionsACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
      </ng-container>
      <div nz-col nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">hi</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'"
          nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table #Table [nzShowTotal]="rangeTemplate" nzBordered nzShowSizeChanger [nzData]="thongtinCSGDList"
      nzSize="small" class="w-full absolute" [nzFrontPagination]="false" [nzTotal]="Total" [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions" [nzLoading]="loading"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" nzLeft rowspan="2">STT
          </th>
          <th rowspan="2" nzWidth="170px">
            Cơ sở/phòng hỗ trợ GD
          </th>
          <th class="text-center" rowspan="2">
            Tổng
          </th>
          <th [attr.colspan]="this.ListCapHoc.length">
            Cấp học trình độ đào tạo
          </th>
          <th [attr.colspan]="this.ListLoaiHinh.length">
            Loại hình cơ sở giáo dục
          </th>
          <th [attr.colspan]="this.ListDieuKien.length">
            Đảm bảo điều kiện tham gia giáo dục của học sinh khuyết tật
          </th>
          <th rowspan="2">
            Ghi Chú
          </th>
        </tr>
        <tr>
          <ng-container *ngFor="let item of ListCapHoc">
            <th class="text-center">{{item.chName}}</th>
          </ng-container>
          <ng-container *ngFor="let item of ListLoaiHinh">
            <th class="text-center">{{item.chName}}</th>
          </ng-container>
          <ng-container *ngFor="let item of ListDieuKien">
            <th class="text-center">{{item.chName}}</th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td class="text-left">{{data.TypeOfEducationName}}</td>
          <td class="text-center">{{data.TypeOfEducationTotal}}</td>
          <ng-container *ngFor="let caphoc of ListCapHoc">
            <td class="text-center">{{data[caphoc.keyId] ? data[caphoc.keyId] : 0}}</td>
          </ng-container>
          <ng-container *ngFor="let loaihinh of ListLoaiHinh">
            <td class="text-center">{{data[loaihinh.keyId] ? data[loaihinh.keyId] : 0}}</td>
          </ng-container>
          <ng-container *ngFor="let dk of ListDieuKien">
            <td class="text-center">{{data[dk.keyId] ? data[dk.keyId] : 0}}</td>
          </ng-container>
          <td></td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
